<template>
  <SogCard
    class="sog-card-without-title"
    style="width: 100%"
  >
    <SogCardContent>
      <table>
        <tr>
          <td>
            <SogDataLabel
              :value="props.data.date"
              :value-type="SogDataLabelValueType.DateTime"
            />
          </td>
        </tr>
        <tr>
          <td>
            <SogDataLabel :value="props.data.actionDescription" />
          </td>
        </tr>
        <tr>
          <td>
            <SogDataLabel :value="props.data.personName" />
          </td>
        </tr>
        <tr v-show="_load">
          <td>
            <SkeletonComponent height="15px" />
          </td>
        </tr>
        <tr v-show="!_load">
          <td>
            <HistoryListItemDetailsComponent :details="_details" />
          </td>
        </tr>
      </table>
    </SogCardContent>
  </SogCard>
</template>

<script setup lang="ts">

import History from "@/shared/model/History";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import {SkeletonComponent} from "@syncfusion/ej2-vue-notifications";
import {ref, watch} from "vue";
import apiHistory from "@/modules/History/api";
import HistoryListItemDetailsComponent from "@/modules/History/components/HistoryListItemDetailsComponent.vue";
import HistoryDetails from "@/shared/model/HistoryDetails";

interface Props {
  data?: History
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    data: undefined
  }
)

const _details = ref<HistoryDetails | undefined>(undefined)

const _load = ref(true)

watch(props, async () => {
    _load.value = true;
    try {
      if (!props.data?.id)
        return
      _details.value = await apiHistory.details(props.data.id)
    } finally {
      _load.value = false;
    }
  },
  {immediate: true})


</script>

<style scoped>

</style>
